import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import PaginationButton from '../styles/PaginationButton';
import Icon from '../Icon';

const PaginationIcon = ({ direction, disabled, handleClick }) => {
    const IconWrapper = styled(PaginationButton)`
        background-color: ${props => props.theme.palette.blueGrey[50]};
        display: flex;
        align-items: center;
        cursor: pointer;
    `;

    return (
        <IconWrapper
            disabled={disabled}
            onClick={handleClick}
            className={disabled ? 'stolo-pager-notclickable' : ''}
        >
            <Icon
                width='1.5em'
                height='1.5em'
                name={`icon-keyboard_arrow_${direction}`}
                iconColor={disabled ? 'blueGrey.200' : 'blueGrey.500'}
            />
        </IconWrapper>
    );
};

PaginationIcon.defaultProps = {
    disabled: false,
};

PaginationIcon.propTypes = {
    direction: PropTypes.oneOf(['left', 'right']).isRequired,
    disabled: PropTypes.bool,
    handleClick: PropTypes.func.isRequired,
};

export default PaginationIcon;



// WEBPACK FOOTER //
// ./src/components/patterngalleries/PaginationIcon.js